import { useCallback } from "react";

export const useRefetchBlendedInApp = () => {
  const refetchBlendedInApp = useCallback(() => {
    try {
      const anyWindow = window as any;
      const data = JSON.stringify({
        topic: "refetch-blended",
      });

      // For React Native WebView, post to the WebView
      if (anyWindow?.ReactNativeWebView) {
        anyWindow?.ReactNativeWebView.postMessage(data);
      } else {
        window.parent.postMessage(data, '*')
      }
    } catch (error) {
      console.error("Error refetching blended in-app:", error);
    }
  }, []);

  return { refetchBlendedInApp };
};
